import { Mapper } from "../../../../../base/utils/mapper";
import { StateCollaboratorModel } from "../../../../../domain/models/configuration/company/state-collaborator.model";
import { StateCollaboratorEntity } from "../../entities/company/state-collaborator.entity";

export class StateCollaboratorImplementationRepositoryMapper extends Mapper<StateCollaboratorEntity, StateCollaboratorModel> {
    mapFrom(param: StateCollaboratorEntity): StateCollaboratorModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: StateCollaboratorModel): StateCollaboratorEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}